import { Stands } from '../Stands';
import { AppConfigs } from './AppConfigs/AppConfigs';

export const services = {
	reki: 'reki',
};

const reki = {
	[Stands.test]: 'https://reki-api.efintest.ru/v1',
	[Stands.cert]: 'https://reki-api.efincert.ru/v1',
	[Stands.prod]: 'https://api-reki.efin.ru/v1',
};

export const sellerBotPaths = ['/'];

export const appSellerConfig = new AppConfigs<typeof services>({
	servicesHosts: {
		reki,
	},
	appHostName: 'seller',
});
export type AppSellerConfig = AppConfigs<typeof services>;
